import { gql } from '@apollo/client';

export interface Input {
  name: string;
  seasonId: number;
}

export const MUTATION = gql`
  mutation UpdateRegistrationForm(
    $id: Int!
    $name: String!
    $seasonId: Int!
    $paymentAccountId: Int
    $openedAt: String
    $closedAt: String
    $organizationPaysProcessingFee: Boolean
    $allowOfflineCheckout: Boolean
  ) {
    updateRegistrationForm(
      id: $id
      input: {
        name: $name
        seasonId: $seasonId
        paymentAccountId: $paymentAccountId
        openedAt: $openedAt
        closedAt: $closedAt
        organizationPaysProcessingFee: $organizationPaysProcessingFee
        allowOfflineCheckout: $allowOfflineCheckout
      }
    ) {
      id
      name
    }
  }
`;
